import { Grid, Icon, css } from '@appd/uik';
import { useEffect, useState } from 'react';
import { ExpressionJson } from 'src/modules/models';
import { TransformedDataSetsProps, TransformedDataSetsColumns } from '../../models';

export const TransformedDataSets = ({ expressionJson }: TransformedDataSetsProps) => {
  const [gridApi, setGridApi] = useState<Grid.GridApi>();
  const [dataSets, setDataSets] = useState<TransformedDataSetsColumns[]>([]);
  const onGridReady: Grid.Props['onGridReady'] = ({ api }) => setGridApi(api);

  useEffect(() => {
    loadAndSetTransformedData(expressionJson);
  }, []);

  const deleteDataSet = () => {
    // Safely obtaining the name of the first selected row or undefined if it does not exist
    const selectedRowName = gridApi?.getSelectedRows()?.[0]?.name;

    // Check if selectedRowName is a non-empty string
    if (typeof selectedRowName === 'string' && selectedRowName.trim().length > 0) {
      setDataSets(prev => prev.filter(dataSet => dataSet.name !== selectedRowName));
    } else {
      console.error('No valid row selected or row data is missing the name property');
    }
  };

  const loadAndSetTransformedData = (expressionJson: Record<string, ExpressionJson>): void => {
    const dataSets = Object.entries(expressionJson).map(([key, value]) => {
      return {
        name: key,
        description: value.description,
        datasource: value.dataSources,
      };
    });
    setDataSets(dataSets);
  };

  const actionNameCellRenderer = () => (
    <div className="flex flex-row items-center">
      <Icon.Action.Edit size="MEDIUM" />
      <Icon.Action.Delete size="MEDIUM" onClick={deleteDataSet} />
    </div>
  );

  const columnsToBeShown = [
    {
      field: 'name',
      headerTooltip: 'Data Sets Name',
      headerName: 'Data Sets Name',
      sortable: true,
    },
    {
      field: 'description',
      headerTooltip: 'Description',
      headerName: 'Description',
      sortable: true,
    },
    {
      field: 'datasource',
      headerTooltip: 'Datasource',
      headerName: 'Datasource',
      sortable: true,
    },
    {
      field: 'actions',
      headerTooltip: 'Actions',
      headerName: 'Actions',
      cellRenderer: actionNameCellRenderer,
      sortable: false,
    },
  ];

  return (
    <div data-testid="datasets-grid" key="dataSetsGrid" className="flex flex-col h-full gap-4">
      <Grid<TransformedDataSetsColumns, any>
        data-testid="transformed-data-sets-grid"
        className={css({ height: '73vh' })}
        columns={columnsToBeShown}
        onGridReady={onGridReady}
        rows={dataSets}
        rowSelection="single"
        showConfigure={false}
      />
    </div>
  );
};
